interface TextProps extends React.HTMLAttributes<HTMLParagraphElement>{
  children: React.ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7' | 'big' | 'h8' |'extraBig' | 'nh6' | 'nh4' | 'nh5' | 'nh8' | 'nh7';
  className?: string;
}

export const TextComponent= ({ children, variant = 'h3', className = '' ,...props}:TextProps) => {
  let baseClass = '';

  switch (variant) {
    case 'extraBig':
      baseClass = 'text-4xl md:text-3xl lg:text-[60px]';/* 60px */
      break;
    case 'big':
      baseClass = 'text-3xl md:text-[45px]';/* 45px */
      break;
    case 'h1':
      baseClass = 'text-2xl md:text-3xl';/* 30px */
      break;
    case 'h2':
      baseClass = 'text-xl md:text-2xl';/* 24px */
      break;
    case 'h3':
      baseClass = 'text-lg md:text-xl';/* 20px */
      break;
    case 'h4':
      baseClass = 'text-base md:text-lg';/* 18px */
      break;
    case 'h5':
      baseClass = 'text-sm md:text-base';/* 16px */
      break;
    case 'h6':
      baseClass = 'text-xs md:text-sm';/* 14px */
      break;
    case 'h7':
      baseClass = 'text-[10px] md:text-xs';/* 12px */
      break;
    case 'h8':
      baseClass = 'text-[8px] md:text-[10px]';/* 12px */
      break;
    case 'nh6':
      baseClass = 'text-base md:text-sm';/* 14px */
      break;
    case 'nh4':
      baseClass = 'text-xl md:text-lg';/* 18px */
      break;
    case 'nh5':
      baseClass = 'text-lg md:text-base';
      break;
    case 'nh8':
      baseClass = 'text-xs md:text-[10px]';
      break;
    case 'nh7':
      baseClass = 'text-sm md:text-xs';
      break;
    default:
      baseClass = 'text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl';
  }

  return <p className={`${baseClass} ${className}`} {...props}>{children}</p>;
};
